<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="1400">
			<v-card>
				<v-card-title class="h6 pr-2">
					<span>Print Preview</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" @click="hideDialog">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="4" class="px-5" app>
							<div class="pb-3">
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Tanggal Pemesanan</div>
									<v-checkbox v-model="poDate" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Status</div>
									<v-checkbox v-model="poStatus" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Alamat Warehouse</div>
									<v-checkbox v-model="warehouseAddress" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Produk Summary</div>
									<v-checkbox v-model="productSummary" class="mt-0" hide-details></v-checkbox>
								</div>
							</div>
							<v-btn large depressed color="cyan darken-2 white--text" class="col-12 mt-5" @click="printDiv(detailOutstanding.po_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2">Print</div>
							</v-btn>
						</v-col>
						<v-col cols="8" class="light-blue lighten-5 rounded-lg frame-pdf">
							<v-card elevation="10" tile class="pa-5" id="section-to-print">
								<div class="white w-100" id="inprint">
									<div class="text-center">
										<img width="90" src="/assets/icon/milagros-icon.png">
									</div>
									<v-row class="pt-2">
										<v-col cols="3">
											<div v-if="poDate" class="text-body-2 font-weight-bold">Tanggal</div>
											<div v-if="poStatus" class="text-body-2 font-weight-bold pt-2">Status</div>
										</v-col>
										<v-col cols="9" class="pl-0">
											<div v-if="poDate" class="text-body-2">{{ detailOutstanding.po_status_wh_approved_datetime | haritanggaljam }}</div>
											<div class="pt-2" v-if="poStatus">{{ detailOutstanding.po_status | toStatusPOWH }}</div>
										</v-col>
									</v-row>
									<div class="pb-3">
										<div class="border-topbot-dotted py-3 mt-3">
											<v-row>
												<v-col cols="6" class="pb-0">
													<v-row>
														<v-col cols="5" class="py-0">
															<div class="text-body-2 font-weight-bold">Nomor</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2 font-weight-bold">{{ detailOutstanding.po_code }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
											<v-row>
												<v-col cols="6">
													<v-row>
														<v-col cols="5" class="py-0">
															<div class="text-body-2">Atas nama</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailOutstanding.supplier_name }}</span>
														</v-col>
														<v-col cols="5" class="py-0">
															<div class="text-body-2">Tanggal</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailOutstanding.po_status_wh_approved_datetime | tanggal }}</span>
														</v-col>
													</v-row>
												</v-col>
												<v-col cols="6">
													<v-row>
														<v-col cols="4" class="py-0">
															<div class="text-body-2">Warehouse</div>
														</v-col>
														<v-col cols="8" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailOutstanding.warehouse_name }}</span>
														</v-col>
														<v-col cols="4" class="py-0">
															<div class="text-body-2">Telephone</div>
														</v-col>
														<v-col cols="8" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailOutstanding.warehouse_mobilephone }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</div>
									</div>
									<div class="pb-3" v-if="warehouseAddress">
										<v-card outlined class="mt-3">
											<v-row class="py-3">
												<v-col cols="12" class="py-0">
													<div class="pl-4 text-body-2 font-weight-bold">Alamat Warehouse</div>
													<div class="pl-4 pt-2 text-body-2">{{ addresText }}</div>
												</v-col>
											</v-row>
										</v-card>
									</div>
									<div class="mt-3" v-if="productSummary">
										<v-card outlined>
											<v-simple-table class="white-row">
												<template v-slot:default>
													<thead class="light-blue lighten-5">
														<tr>
															<th class="text-left">Nama Produk</th>
															<th class="text-center">Outstanding</th>
															<th class="text-center">Sedang Dikirim</th>
															<th class="text-center">Belum Dikirim</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="product in detailOutstanding.detail" :key="product.por_detail_id">
															<td class="text-left">{{ product.po_detail_product_name }}</td>
															<td class="text-center">{{ product.po_detail_outstanding.outstanding }}</td>
															<td class="text-center">{{ product.po_detail_outstanding.on_delivery }}</td>
															<td class="text-center">{{ product.po_detail_outstanding.draft }}</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
									</div>
								</div>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'
import printJS from 'print-js'

export default {
	data () {
		return {
			poDate: true,
			poStatus: true,
			warehouseAddress: true,
			productSummary: true,
		}
	},
	computed: {
		...mapState('poOutstanding', ['detailOutstanding']),

		addresText() {
			var data = []
			if (this.detailOutstanding) {
				if (this.detailOutstanding.warehouse_address)
					data.push(this.detailOutstanding.warehouse_address)
				if (this.detailOutstanding.warehouse_subdistrict_name)
					data.push(this.detailOutstanding.warehouse_subdistrict_name)
				if (this.detailOutstanding.warehouse_city_name)
					data.push(this.detailOutstanding.warehouse_city_name)
				if (this.detailOutstanding.warehouse_province_name)
					data.push(this.detailOutstanding.warehouse_province_name)
			}
			return data.join(', ')
		},
		grandTotal(){
			let total = 0
			if (this.detailOutstanding.por_detail) {
				if (this.detailOutstanding.por_status == 'approved') {
					this.detailOutstanding.por_detail.forEach( (el) => {
						total += el.por_detail_product_price * el.por_detail_quantity_approved
					});
				} else {
					this.detailOutstanding.por_detail.forEach( (el) => {
						total += el.por_detail_product_price * el.por_detail_quantity_requested
					});
				}
			}
			return total
		}
	},
	props: {
		dialog: Boolean
	},
	methods: {
		hideDialog() {
			this.$emit('hideDialog')
		},
		printDiv(val) {
			var tempTitle = document.title
			document.title = val
			printJS({
				printable: "inprint",
				type: "html",
				maxWidth: "1000",
				targetStyles: ["*"],
				documentTitle: val,
			});
			setTimeout(() => { document.title = tempTitle }, 5000)
		}
	},
	watch: {
		dialog(val) {
			if (!val) {
				this.poDate = true
				this.poStatus = true
				this.warehouseAddress = true
				this.productSummary = true
			}
		}
	},
};
</script>